// extracted by mini-css-extract-plugin
export default {"shortLabelWrapper":"LabeledText_shortLabelWrapper__dK5C9","shortLabel":"LabeledText_shortLabel__u8QRN","shortValue":"LabeledText_shortValue__YlTtF"};